import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { close } from "ionicons/icons";
import { useCallback, useEffect, useRef } from "react";
import { shouldUseIonicComponents } from "../../utils/platformUtils";
import "../styles/modal.css";

const Modal = (props) => {
  const { isOpen, onClose, Content, styleOverlay, styleContent, title } = props;
  const modalRef = useRef();
  const useMobileUI = shouldUseIonicComponents();

  // Close the modal if the user clicks outside the modal content
  const handleOutsideClick = useCallback(
    (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen && !useMobileUI) {
      // Use mousedown instead of click and delay to avoid immediate closure
      const timer = setTimeout(() => {
        document.addEventListener("mousedown", handleOutsideClick);
      }, 100);

      return () => {
        clearTimeout(timer);
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [isOpen, handleOutsideClick, useMobileUI]);

  // Render Ionic modal for mobile
  if (useMobileUI) {
    return (
      <IonModal 
        isOpen={isOpen} 
        onDidDismiss={onClose}
        breakpoints={[0, 0.5, 0.75, 0.85, 1]}
        initialBreakpoint={0.85}
        style={{ "--width": "85%", "--height": "85%" }}
      >
        {title && (
          <IonHeader>
            <IonToolbar>
              <IonTitle>{title}</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={onClose}>
                  <IonIcon icon={close} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
        )}
        <IonContent className="ion-padding">
          <Content />
        </IonContent>
      </IonModal>
    );
  }

  // Render web modal (existing design)
  return (
    <div>
      {isOpen && (
        <div className="modal-overlay" style={styleOverlay}>
          <div className="modal-content" style={styleContent} ref={modalRef}>
            <span className="close" onClick={onClose}>
              &times;
            </span>
            <Content />
          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;
